import { useRef, useState } from "react";

async function fallbackCopy(text: string) {
	const textarea = document.createElement("textarea");
	textarea.value = text;
	textarea.setAttribute("readonly", "true");
	textarea.style.position = "absolute";
	textarea.style.left = "-9999px";
	document.body.appendChild(textarea);
	textarea.select();
	document.execCommand("copy");
	document.body.removeChild(textarea);
}

export function useCopy(resetAfterMs = 1500): readonly [boolean, (text: string) => Promise<void>] {
	const [copied, setCopied] = useState(false);
	const timeoutRef = useRef<number | null>(null);

	async function copy(text: string) {
		if (typeof navigator !== "undefined" && navigator.clipboard?.writeText) {
			await navigator.clipboard.writeText(text);
		} else {
			await fallbackCopy(text);
		}

		setCopied(true);
		if (timeoutRef.current !== null) {
			window.clearTimeout(timeoutRef.current);
		}
		timeoutRef.current = window.setTimeout(() => setCopied(false), resetAfterMs);
	}

	return [copied, copy] as const;
}
